import { FrontPageReviewItem } from 'components/Pages/FrontPage/USP/Reviews/FrontPageReviewCard'

const singaporeReviews: Array<FrontPageReviewItem> = [
  {
    content: 'They provided us with an exceptional value package for a stay at Avani+ resort in Khao Lak, Thailand. We were very well taken care of by the staff who recognised the booking from LE as important and even had a specially curated menu for LE guests.',
    name: 'Rawna B',
    source: 'trustpilot',
  },
  {
    content: 'The resort was beautiful. Tucked away from the hustle and bustle of Seminyak, but close enough to walk or catch the shuttle to experience everything that make Bali so fantastic. The rooms are beautifully appointed, the staff are so friendly and nothing was ever too much.',
    name: 'Jarrod W',
    source: 'trustpilot',
  },
  {
    content: 'This is our second trip with Luxury Escape. The first time was to Maldives a year ago. The coming tour is 12 days to Sri Lanka in 2025. We are very pleased to work with Luxury Escape from day 1. They are very responsive and helpful. They are in Australia and we are in Singapore...',
    name: 'Aston C',
    source: 'trustpilot',
  },
  {
    content: 'Hotels and resort was fabulous. I\'m asking myself why I didn\'t take a luxury escape sooner. The Vin Pearl Villla in Vietnam has set a high benchmark and may have spoilt us for other villas and the Sofitel in KL was perfect. Luxury escapes administration provided excellent service…',
    name: 'Julia D',
    source: 'trustpilot',
  },
  {
    content: 'This escape was planned from beginning to end. The Intercontinental Hotel in Singapore was excellent. We felt special from the minute they opened our car door for us. The inclusions were excellent.',
    name: 'Patricia A',
    source: 'trustpilot',
  },
  {
    content: 'Yet again another great holiday booking via Luxury Escapes. A personal thank you to Tammie R for sorting out our bookings to accommodate the kids and family. It truly took the stress out of booking and making changes to get it right. She was patient and kind. She actioned our requests promptly and followed up…',
    name: 'A Nazareth',
    source: 'trustpilot',
  },
  {
    content: 'I have booked 2 trips with Luxury Escapes. The first was so amazing that we had to book again! I needed to get some additional information and called. Emily H. was so helpful. She gave me the different options and followed up. I highly recommend booking your next vacation with Luxury Escapes.',
    name: 'Stracy A',
    source: 'google',
  },
]

const hongKongReviews: Array<FrontPageReviewItem> = [
  {
    content: 'Our Phuket accommodation booked through Luxury Escapes was excellent value for money. All the extra food, beverage and spa vouchers made it even better. I don\'t know how they could do it for the price.',
    name: 'Julia A',
    source: 'trustpilot',
  },
  {
    content: 'The resort was beautiful. Tucked away from the hustle and bustle of Seminyak, but close enough to walk or catch the shuttle to experience everything that make Bali so fantastic. The rooms are beautifully appointed, the staff are so friendly and nothing was ever too much.',
    name: 'Jarrod W',
    source: 'trustpilot',
  },
  {
    content: 'Hotels and resort was fabulous. I\'m asking myself why I didn\'t take a luxury escape sooner. The Vin Pearl Villla in Vietnam has set a high benchmark and may have spoilt us for other villas and the Sofitel in KL was perfect. Luxury escapes administration provided excellent service…',
    name: 'Julia D',
    source: 'trustpilot',
  },
  {
    content: 'Yet again another great holiday booking via Luxury Escapes. A personal thank you to Tammie R for sorting out our bookings to accommodate the kids and family. It truly took the stress out of booking and making changes to get it right. She was patient and kind. She actioned our requests promptly and followed up…',
    name: 'A Nazareth',
    source: 'trustpilot',
  },
  {
    content: 'I have booked 2 trips with Luxury Escapes. The first was so amazing that we had to book again! I needed to get some additional information and called. Emily H. was so helpful. She gave me the different options and followed up. I highly recommend booking your next vacation with Luxury Escapes.',
    name: 'Stracy A',
    source: 'google',
  },
]

const malaysiaReviews: Array<FrontPageReviewItem> = [
  {
    content: 'The resort was beautiful. Tucked away from the hustle and bustle of Seminyak, but close enough to walk or catch the shuttle to experience everything that make Bali so fantastic. The rooms are beautifully appointed, the staff are so friendly and nothing was ever too much.',
    name: 'Jarrod W',
    source: 'trustpilot',
  },
  {
    content: 'We booked a Luxury Escape to the Maldives for our 20th Wedding Anniversary and could not speak more highly of the fantastic deal we got. We were blessed to experience this beautiful place only thanks to the amazing deal that Luxury Escapes offered which included all our meals and alcohol. Couldn\'t recommend it more to anyone looking.',
    name: 'Louise M',
    source: 'trustpilot',
  },
  {
    content: 'Our Phuket accommodation booked through Luxury Escapes was excellent value for money. All the extra food, beverage and spa vouchers made it even better. I don\'t know how they could do it for the price.',
    name: 'Julia A',
    source: 'trustpilot',
  },
  {
    content: 'Yet again another great holiday booking via Luxury Escapes. A personal thank you to Tammie R for sorting out our bookings to accommodate the kids and family. It truly took the stress out of booking and making changes to get it right. She was patient and kind. She actioned our requests promptly and followed up…',
    name: 'A Nazareth',
    source: 'trustpilot',
  },
  {
    content: 'I have booked 2 trips with Luxury Escapes. The first was so amazing that we had to book again! I needed to get some additional information and called. Emily H. was so helpful. She gave me the different options and followed up. I highly recommend booking your next vacation with Luxury Escapes.',
    name: 'Stracy A',
    source: 'google',
  },
]

const southAfricaReviews: Array<FrontPageReviewItem> = [
  {
    content: 'Our Phuket accommodation booked through Luxury Escapes was excellent value for money. All the extra food, beverage and spa vouchers made it even better. I don\'t know how they could do it for the price.',
    name: 'Julia A',
    source: 'trustpilot',
  },
  {
    content: 'We had a fabulous holiday at Moeveñpick Resort & Spa Phuket. The accommodation was beautiful; facilities were perfect for what we needed, selection of restaurants and meals was great. Above all, the staff at the Resort were wonderful; so cheery and friendly…',
    name: 'Deidre B',
    source: 'trustpilot',
  },
  {
    content: 'The resort is beautiful. Tucked away from the hustle and bustle of Seminyak, but close enough to walk or catch the shuttle to experience everything that make Bali so fantastic. The rooms are beautifully appointed, the staff are so friendly and nothing was ever too much.',
    name: 'Jarrod W',
    source: 'trustpilot',
  },
  {
    content: 'We booked a Luxury Escape to the Maldives for our 20th Wedding Anniversary and could not speak more highly of the fantastic deal we got. We were blessed to experience this beautiful place only thanks to the amazing deal that Luxury Escapes offered which included all our meals and alcohol. Couldn\'t recommend it more to anyone looking.',
    name: 'Louise M',
    source: 'trustpilot',
  },
  {
    content: 'Yet again another great holiday booking via Luxury Escapes. A personal thank you to Tammie R for sorting out our bookings to accommodate the kids and family. It truly took the stress out of booking and making changes to get it right. She was patient and kind. She actioned our requests promptly and followed up…',
    name: 'A Nazareth',
    source: 'trustpilot',
  },
  {
    content: 'I have booked 2 trips with Luxury Escapes. The first was so amazing that we had to book again! I needed to get some additional information and called. Emily H. was so helpful. She gave me the different options and followed up. I highly recommend booking your next vacation with Luxury Escapes.',
    name: 'Stracy A',
    source: 'google',
  },
]

const reviewsByRegion = new Map([['SG', singaporeReviews], ['HK', hongKongReviews], ['MY', malaysiaReviews], ['ZA', southAfricaReviews]])
export default function getFrontPageReviews(regionCode: string) {
  return reviewsByRegion.get(regionCode.toUpperCase())
}
